module.exports = __webpack_public_path__ + "static/img/bg_5.8899011.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/bg_5.png
// module id = 787
// module chunks = 1